import {
  useObtenerBalanceGeneral,
  useObtenerMayorGeneral,
  useObtenerPeriodosFiscales,
  useObtenerPeriodosContables,
  useObtenerCuentas,
  useObtenerDiarioRazon,
  useFuentesDocumento,
  useExpresadoEn,
} from "../../Scripts/Services/contabilidad-service.js";
import { convertirDatos } from "../../Scripts/Utils/convertirDatos.js";
import React, {useState, useEffect, useRef} from 'react';
import { TreeTable, DataTable, Column, Skeleton, Calendar, addLocale } from 'primereact';
import {Message, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {formatearNumero} from "../../../Commons/Scripts/Utils/formatear";
import Select from "react-select";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";

addLocale("es", {
  firstDayOfWeek: 1,
  showMonthAfterYear: true,
  dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
  monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  today: "Hoy",
  clear: "Limpiar",
});

const REPORTE_EXPRESAR = {
  EN_MILES: "K",
  EN_CIENTOS_MILES: "CK",
  EN_MILLONES: "M",
  EN_UNIDADES: "U",
};

const BalanceGeneral = ({
  data,
  loading,
  setWhere,
  where,
  expandedKeys,
  setExpandedKeys,
  handleFiltro,
  error,
  form,
  dataExpresadoEn,
  expresado,
  setExpresado,
  isBalanceGeneral,
  isMayorGeneral,
  setTab,
}) => {
  const { useState, useEffect } = React;
  const {
    fecha,
    periodoFiscal,
    periodoContable,
    expresadoEn,
    setFecha,
    setPeriodoFiscal,
    setPeriodoContable,
    setExpresadoEn,
  } = form;
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.BALANCE_GENERAL, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.BALANCE_GENERAL, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.BALANCE_GENERAL, "CSV");

  /* where */
  const [wherePeriodosContables, setWherePeriodosContables] = useState({ where: {} });

  const { data: dataPeriodosFiscales } = useObtenerPeriodosFiscales();
  const { data: dataPeriodosContables } = useObtenerPeriodosContables(wherePeriodosContables);

  const [nodos, setNodos] = useState([]);

  /* estados derivados */
  const periodosFiscales = dataPeriodosFiscales?.Resultados
    ? [
        { value: -1, label: "Seleccione un periodo fiscal" },
        ...dataPeriodosFiscales?.Resultados?.map((item) => ({
          value: item.IdSec,
          label: item.Descripcion,
        })),
      ]
    : [];

  const periodosContables = dataPeriodosContables?.Resultados
    ? [
        { value: -1, label: "Seleccione un periodo contable" },
        ...dataPeriodosContables?.Resultados?.map((item) => ({
          value: item.IdSec,
          label: item.Descripcion,
        })),
      ]
    : [];

  useEffect(() => {
    const respuesta = data?.Resultados?.Cuentas;
    if (respuesta) {
      var reporte = convertirDatos(respuesta);
      setNodos(reporte);
    }
  }, [data]);

  const handleFecha = (e) => {
    setFecha(e.target.value);
  };

  const handlePeriodoFiscal = (e) => {
    setPeriodoFiscal(e);
    setPeriodoContable(null);
    setWherePeriodosContables({
      where: {
        PeriodoFiscalIdSec: e === null ? -1 : parseInt(e.value),
      },
    });
  };

  const handlePeriodoContable = (e) => {
    setPeriodoContable(e);
  };

  const filtrar = (fila) => {
    const data = {
      Cuenta: {
        IdSec: fila.IdSec,
        Nombre: fila.Descripcion,
        IdentificadorCuenta: fila.IdentificadorCuenta,
      },
    };
    handleFiltro(data);
  };

  const total = (rowData) => {
    const formatter = new Intl.NumberFormat("es-DO");

    const balance = rowData?.data?.BalancePeriodoActual + rowData?.data?.BalancePeriodoAnterior;

    const isExpandable = rowData.children !== null && rowData.children !== undefined && rowData.children.length > 0;

    const isTotal = rowData.data.IdentificadorCuenta === "resultado";

    if (isExpandable && expandedKeys[rowData.key]) {
      return null;
    } else {
      return (
        <div>
          {isTotal ? (
            <span>{formatter.format(getCifraFormateadoPorTipoExpresion(balance))}</span>
          ) : (
            <span className="link" onClick={() => filtrar(rowData?.data)}>
              {formatter.format(getCifraFormateadoPorTipoExpresion(balance))}
            </span>
          )}
        </div>
      );
    }
  };

  const getCifraFormateadoPorTipoExpresion = (monto) => {
    let formateado = monto;
    switch (expresado) {
      case REPORTE_EXPRESAR.EN_MILES:
        formateado /= 1000;
        break;
      case REPORTE_EXPRESAR.EN_CIENTOS_MILES:
        formateado /= 100000;
        break;
      case REPORTE_EXPRESAR.EN_MILLONES:
        formateado /= 1000000;
        break;
      case REPORTE_EXPRESAR.EN_UNIDADES:
        formateado = Math.round(formateado);
        break;
      default:
        break;
    }
    return formateado;
  };

  const handleBuscar = () => {
    setExpresado(expresadoEn.value);

    setWhere({
      where: {
        PeriodoFiscalInicioIdSec: periodoFiscal === null ? -1 : parseInt(periodoFiscal.value),
        PeriodoContableInicioIdSec: periodoContable === null ? -1 : parseInt(periodoContable.value),
        FechaFin: fecha === null ? "" : fecha?.toISOString().split("T")[0],
      },
    });
  };

  const handleRowClick = (e) => {
    const clickedColumnIndex = e.originalEvent.target.cellIndex;
    if (clickedColumnIndex === 0) {
      const newExpandedKeys = { ...expandedKeys };
      if (newExpandedKeys[e.node.key]) {
        delete newExpandedKeys[e.node.key];
      } else {
        newExpandedKeys[e.node.key] = true;
      }
      setExpandedKeys(newExpandedKeys);
    }
  };

  const styles = {
    control: (base) => ({
      ...base,
      minHeight: "0",
      border: "#97bdc1 solid 1px",
      boxShadow: "2px 2px 0 #d7e6e7, -2px 2px 0 #d7e6e7, 2px -2px 0 #d7e6e7, -2px -2px 0 #d7e6e7",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  const calendarStyles = {
    padding: "4px 8px",
    borderRadius: "3px",
    border: "#97bdc1 solid 1px",
    boxShadow: "2px 2px 0 #d7e6e7, -2px 2px 0 #d7e6e7, 2px -2px 0 #d7e6e7, -2px -2px 0 #d7e6e7",
    width: 'unset'
  };

  return (
    <React.Fragment>
      <Message messages={messages} type={typeMessages} />

      <div className="row">
        <div className="label">Periodo Fiscal</div>
        <div className="control" style={{ width: "250px" }}>
          <Select
            value={periodoFiscal}
            options={periodosFiscales}
            onChange={handlePeriodoFiscal}
            placeholder="Seleccione un periodo fiscal"
            styles={styles}
          />
        </div>
      </div>
      <div className="row">
        <div className="label">Periodo Contable</div>
        <div className="control" style={{ width: "250px" }}>
          <Select
            value={periodoContable}
            options={periodosContables}
            onChange={handlePeriodoContable}
            placeholder="Seleccione un periodo contable"
            styles={styles}
          />
        </div>
      </div>
      <div className="row">
        <div className="label">Fecha Fin</div>
        <div className="control" style={{ display: "flex", alignItems: "center" }}>
          <Calendar
            value={fecha}
            onChange={handleFecha}
            dateFormat="dd/mm/yy"
            locale="es"
            mask="99/99/9999"
            inputStyle={calendarStyles}
          />
        </div>
      </div>

      <div className="row">
        <div className="label">Expresado en:</div>
        <div className="control" style={{ width: "150px" }}>
          <Select
            value={expresadoEn}
            options={dataExpresadoEn?.Resultados}
            onChange={(value) => {
              setExpresadoEn(value);
            }}
            styles={styles}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 150px",
        }}
      >
        <Button2 texto="Buscar" onClick={handleBuscar} />
        <Button2 texto="PDF" loading={loadingPdf}  onClick={() => handlePdf()} />
        <Button2 texto="Excel" loading={loadingExcel}  onClick={() => handleExcel()} />
        <Button2 texto="CSV" loading={loadingCsv}  onClick={() => handleCsv()} />
      </div>

      <br />
      <br />
      <div className="inMenu">
        <div className="inMenuItem">
          <span className={isBalanceGeneral ? "subTitle" : "linkSubtitulo"} onClick={() => setTab("BALANCE_GENERAL")}>
            Balance General
          </span>
        </div>
        <div className="inMenuItem">|</div>
        <div className="inMenuItem">
          <span className={isMayorGeneral ? "subTitle" : "linkSubtitulo"} onClick={() => setTab("MAYOR_GENERAL")}>
            Mayor General
          </span>
        </div>
        <div className="fix"></div>
      </div>
      <br />

      {loading && (
        <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}

      {!loading && (
        <TreeTable
          id="grid"
          rowClassName={(rowData) => ({
            total: rowData.data.IdentificadorCuenta === "resultado",
          })}
          value={nodos}
          expandedKeys={expandedKeys}
          onToggle={(e) => setExpandedKeys(e.value)}
          tableStyle={{
            minWidth: "50rem",
          }}
          onRowClick={handleRowClick}
          emptyMessage="No se han encontrado resultados"
        >
          <Column style={{ width: "75%" }} field="CuentaDesc" expander></Column>
          <Column header="Balance General" body={total} style={{ textAlign: "right" }}></Column>
        </TreeTable>
      )}
    </React.Fragment>
  );
};

const initialForm = {
  periodoFiscal: null,
  periodoContable: null,
  FechaInicio: new Date(new Date().setMonth(new Date().getMonth() - 1)),
  FechaFin: new Date(),
  cuentas: [],
  tipoDocumento: { value: "-1", label: "Todos" },
  razon: null,
  sinMovimiento: false,
};

const origin = window.location.origin;

const MayorGeneral = ({
  data,
  loading,
  filtros,
  setWhere,
  where,
  filtrosRef,
  error,
  form,
  setForm,
  isBalanceGeneral,
  isMayorGeneral,
  setTab,
}) => {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.MAYOR_GENERAL, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.MAYOR_GENERAL, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.MAYOR_GENERAL, "CSV");

  const [wherePeriodosContables, setWherePeriodosContables] = useState(() => ({
    where: {},
  }));
  const [whereCuentas, setWhereCuentas] = useState({
    where: {
      EsPaginable: false,
    },
  });

  const { data: fuentesDocumento } = useFuentesDocumento();

  const { data: dataPeriodosFiscales } = useObtenerPeriodosFiscales();

  const { data: dataPeriodosContables } = useObtenerPeriodosContables(wherePeriodosContables);

  const { data: dataCuentas } = useObtenerCuentas(whereCuentas);

  const { data: dataRazones } = useObtenerDiarioRazon();

  const [expandedRows, setExpandedRows] = useState([]);

  /* estados derivados */

  const cuentas = dataCuentas?.Resultados?.map((item) => ({
    value: item.IdentificadorCuenta,
    label: item.Nombre,
  }));

  const periodosFiscales = dataPeriodosFiscales?.Resultados
    ? [
        { value: -1, label: "Seleccione un periodo fiscal" },
        ...dataPeriodosFiscales?.Resultados?.map((item) => {
          return {
            value: item.IdSec,
            label: item.Descripcion,
          };
        }),
      ]
    : [];

  const periodosContables = dataPeriodosContables?.Resultados
    ? [
        { value: -1, label: "Seleccione un periodo contable" },
        ...dataPeriodosContables?.Resultados?.map((item) => ({
          value: item.IdSec,
          label: item.Descripcion,
        })),
      ]
    : [];

  const razones = dataRazones?.Resultados
    ? [
        { value: -1, label: "Seleccione una razón" },
        ...dataRazones?.Resultados?.map((item) => ({
          value: item.IdSec,
          label: item.Razon,
        })),
      ]
    : [];

  useEffect(() => {
    if (filtros) {
      const cuentas = filtros.Cuenta.IdentificadorCuenta;

      if (filtrosRef.current !== filtros) {
        setWhere({
          where: {
            FechaInicio: form?.FechaInicio?.toISOString().split("T")[0],
            FechaFin: form?.FechaFin?.toISOString().split("T")[0],
            CuentasIdentificadorLista: [cuentas],
          },
        });
        filtrosRef.current = filtros;
      }

      setForm((prevForm) => ({
        ...prevForm,
        cuentas: [
          {
            label: filtros.Cuenta.Nombre,
            value: filtros.Cuenta.IdentificadorCuenta,
          },
        ],
      }));
    }
  }, [filtros]);

  useEffect(() => {
    handleException(error);
  }, [error]);

  const handleChange = (e) => {
    setForm((currentForm) => {
      return {
        ...currentForm,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleCheck = (e) => {
    setForm((currentForm) => {
      return {
        ...currentForm,
        [e.target.name]: e.target.checked,
      };
    });
  };

  const handleSubmit = () => {
    const formCuentas = form.cuentas?.map((item) => item.value);

    const consulta = {
      where: {
        FechaInicio: form.FechaInicio?.toISOString().split("T")[0],
        FechaFin: form.FechaFin?.toISOString().split("T")[0],
        PeriodoContableIdSec: form.periodoContable?.value,
        PeriodoFiscalIdSec: form.periodoFiscal?.value,
        TipoDocumentoIdSec: form.tipoDocumento?.value,
        CuentasIdentificadorLista: formCuentas,
        RazonIdSec: form.razon?.value,
        SinMovimiento: form.sinMovimiento,
      },
    };

    setWhere(consulta);
  };

  const handlePeriodoFiscal = (data) => {
    setForm((currentForm) => ({
      ...currentForm,
      periodoContable: null,
      periodoFiscal: data,
    }));
    setWherePeriodosContables({
      where: {
        PeriodoFiscalIdSec: data === null ? -1 : parseInt(data.value),
      },
    });
  };

  const handlePeriodoContable = (data) => {
    setForm((currentForm) => ({
      ...currentForm,
      periodoContable: data,
    }));
  };

  const handleRazon = (data) => {
    setForm((currentForm) => ({
      ...currentForm,
      razon: data,
    }));
  };

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span
          onClick={() =>
            setExpandedRows((prevState) => {
              const existingRow = prevState.find((row) => row.IdentificadorCuenta === data.IdentificadorCuenta);
              if (existingRow) {
                return prevState.filter((row) => row.IdentificadorCuenta !== data.IdentificadorCuenta);
              } else {
                return [...prevState, data];
              }
            })
          }
        >
          {data.CuentaNombre} - {data.IdentificadorCuenta}
        </span>
        <span style={{ display: "block", width: "100%", textAlign: "right" }}>
          <b>Saldo Inicial: </b>
          {formatearNumero(data.SaldoInicial)}
        </span>
      </React.Fragment>
    );
  };

  const footerTemplate = (data) => {
    return (
      <React.Fragment>
        <td colSpan={8}>
          <div className="container-resultado">
            <div className="tabla">
              <div className="fila">
                <div className="celda">Débito: </div>
                <div className="celda">{formatearNumero(data.DebitoFinal)}</div>
              </div>
              <div className="fila">
                <div className="celda">Crédito: </div>
                <div className="celda">{formatearNumero(data.CreditoFinal)}</div>
              </div>
              <div className="fila">
                <div className="celda">Balance: </div>
                <div className="celda">{formatearNumero(data.BalanceFinal)}</div>
              </div>
            </div>
          </div>
        </td>
      </React.Fragment>
    );
  };

  const getLinkDocumento = (data) => {
    let link = `${origin}/`;

    if (data.Tipo === "Factura Cliente") {
      link += "Facturacion/factura_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Factura Suplidor") {
      link += "CxP/factura_suplidor_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Recibo") {
      link += "CxC/recibo_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Anticipo CxC") {
      link += "CxC/anticipo_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Anticipo CxP" || data.Tipo === "Anticipo Aplicado CxP") {
      link += "CxP/anticipo_cxp_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Cargo Bancario") {
      link += "Activos/cargo_bancario_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Credito Bancario") {
      link += "Activos/credito_bancario_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Cierre de Caja") {
      link += "Facturacion/cierre_caja_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Conduce") {
      link += "Facturacion/conduce_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Deposito Bancario") {
      link += "Activos/deposito_bancario_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Transferencia Bancaria") {
      link += "Activos/transferencia_bancaria_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Entrada a Almacén") {
      link += "Inventario/entrada_almacen_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Gasto") {
      link += "Contabilidad/gastos_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Nota de Crédito (CxC)") {
      link += "CxC/nota_credito_cxc_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Nota de Débito (CxC)") {
      link += "CxC/nota_debito_cxc_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Nota de Crédito (CxP)") {
      link += "CxP/nota_credito_cxp_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Nota de Débito (CxP)") {
      link += "CxP/nota_debito_cxp_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Salida de Almacén") {
      link += "Inventario/salida_almacen_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Traslado de Almacén") {
      link += "Inventario/traslado_almacen_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Devolución de Anticipo") {
      link += "CxC/devolucion_anticipo_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Prestamo") {
      link += "Nomina/prestamo_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Diario") {
      link += "Contabilidad/diario_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Cheque") {
      link += "Activos/cheque_edit.aspx?IdSec=" + data.Referencia;
    } else if (data.Tipo === "Existencia de Almacén") {
      link += "Inventario/ver_ajuste.aspx?ajusteIdSec=" + data.Referencia;
    } else {
      link = "";
    }

    return link;
  };

  const getLinkDiario = (data) => {
    const link = `${origin}/`;

    return link + "Contabilidad/diario_edit.aspx?IdSec=" + data.Numero;
  };

  const tipoTemplate = (data) => {
    const link = getLinkDocumento(data);

    return (
      <React.Fragment>
        {link === "" ? (
          <span>{data.Tipo}</span>
        ) : (
          <a className="link" href={link} target="_blank">
            {data.Tipo}
          </a>
        )}
      </React.Fragment>
    );
  };

  const referenciaTemplate = (data) => {
    const link = getLinkDocumento(data);

    return (
      <React.Fragment>
        {link === "" ? (
          <span>{data.Referencia}</span>
        ) : (
          <a className="link" href={link} target="_blank">
            {data.Referencia}
          </a>
        )}
      </React.Fragment>
    );
  };

  const diarioTemplate = (data) => {
    const link = getLinkDiario(data);

    return (
      <React.Fragment>
        <a className="link" href={link} target="_blank">
          {data.Numero}
        </a>
      </React.Fragment>
    );
  };

  const debitoTemplate = (data) => {
    const link = getLinkDiario(data);

    return (
      <React.Fragment>
        <a className="link" href={link} target="_blank">
          {formatearNumero(data.Debito)}
        </a>
      </React.Fragment>
    );
  };

  const creditoTemplate = (data) => {
    const link = getLinkDiario(data);

    return (
      <React.Fragment>
        <a className="link" href={link} target="_blank">
          {formatearNumero(data.Credito)}
        </a>
      </React.Fragment>
    );
  };

  const balanceTemplate = (data) => {
    const link = getLinkDiario(data);

    return (
      <React.Fragment>
        <a className="link" href={link} target="_blank">
          {formatearNumero(data.Balance)}
        </a>
      </React.Fragment>
    );
  };

  const fechaTemplate = (data) => {
    return <React.Fragment>{data.FechaTransaccion}</React.Fragment>;
  };

  const styles = {
    control: (base) => ({
      ...base,
      minHeight: "0",
      border: "#97bdc1 solid 1px",
      boxShadow: "2px 2px 0 #d7e6e7, -2px 2px 0 #d7e6e7, 2px -2px 0 #d7e6e7, -2px -2px 0 #d7e6e7",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  const calendarStyles = {
    padding: "4px 8px",
    borderRadius: "3px",
    border: "#97bdc1 solid 1px",
    boxShadow: "2px 2px 0 #d7e6e7, -2px 2px 0 #d7e6e7, 2px -2px 0 #d7e6e7, -2px -2px 0 #d7e6e7",
    width: 'unset'
  };

  return (
    <div>
      {error && <Message messages={messages} type={typeMessages} />}

      <div className="row">
        <div className="label">Fecha Inicio</div>
        <div className="control">
          <Calendar
            name="FechaInicio"
            value={form.FechaInicio}
            onChange={handleChange}
            dateFormat="dd/mm/yy"
            locale="es"
            mask="99/99/9999"
            inputStyle={calendarStyles}
          />
        </div>
        <div className="fix"></div>
      </div>
      <div className="row">
        <div className="label">Fecha Fin</div>
        <div className="control">
          <Calendar
            name="FechaFin"
            value={form.FechaFin}
            onChange={handleChange}
            dateFormat="dd/mm/yy"
            locale="es"
            mask="99/99/9999"
            inputStyle={calendarStyles}
          />
        </div>
        <div className="fix"></div>
      </div>
      <div className="row">
        <div className="label">Periodo Fiscal</div>
        <div className="control" style={{ width: "250px" }}>
          <Select
            value={form.periodoFiscal}
            options={periodosFiscales}
            onChange={handlePeriodoFiscal}
            placeholder="Seleccione un periodo fiscal"
            styles={styles}
          />
        </div>
        <div className="fix"></div>
      </div>
      <div className="row">
        <div className="label">Periodo Contable</div>
        <div className="control" style={{ width: "250px" }}>
          <Select
            value={form.periodoContable}
            options={periodosContables}
            onChange={handlePeriodoContable}
            placeholder="Seleccione un periodo contable"
            styles={styles}
          />
        </div>
        <div className="fix"></div>
      </div>

      <div className="row">
        <div className="label">Cuenta</div>
        <div className="control" style={{ width: "500px" }}>
          <Select
            isMulti
            name="cuentas"
            options={cuentas}
            onChange={(cuentasActuales) => {
              setForm((currentForm) => ({
                ...currentForm,
                cuentas: cuentasActuales,
              }));
            }}
            placeholder="Cuentas..."
            value={form.cuentas}
            styles={styles}
          />
        </div>
        <div className="fix"></div>
      </div>
      <div className="row">
        <div className="label">Tipo Documento</div>
        <div className="control" style={{ width: "200px" }}>
          <Select
            value={form.tipoDocumento}
            options={fuentesDocumento?.Resultados?.map((item) => ({
              label: item.label,
              value: item.value,
            }))}
            onChange={(data) => {
              setForm((currentForm) => ({
                ...currentForm,
                tipoDocumento: data,
              }));
            }}
            styles={styles}
          />
        </div>
        <div className="fix"></div>
      </div>
      <div className="row">
        <div className="label">Razon</div>
        <div className="control" style={{ width: "200px" }}>
          <Select value={form.razon} options={razones} onChange={handleRazon} placeholder="Todos" styles={styles} />
        </div>
        <div className="fix"></div>
      </div>

      <div className="row">
        <div className="label">Sin Movimiento</div>
        <div className="control">
          <div className="checkbox-outer">
            <input type="checkbox" name="sinMovimiento" onChange={handleCheck} checked={form.sinMovimiento} />
          </div>
        </div>
        <div className="fix"></div>
      </div>
      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 150px",
          width: "100%",
        }}
      >
        <Button2 texto="Buscar" icono="buscar" onClick={handleSubmit} />
        <Button2 texto="PDF" icono="pdf" loading={loadingPdf} onClick={() => handlePdf({ ...where.where })} />
        <Button2 texto="Excel" icono="excel" loading={loadingExcel} onClick={() => handleExcel({ ...where.where })} />
        <Button2 texto="CSV" icono="excel" loading={loadingCsv} onClick={() => handleCsv({ ...where.where })} />
      </div>

      <br />
      <br />
      <div className="inMenu">
        <div className="inMenuItem">
          <span className={isBalanceGeneral ? "subTitle" : "linkSubtitulo"} onClick={() => setTab("BALANCE_GENERAL")}>
            Balance General
          </span>
        </div>
        <div className="inMenuItem">|</div>
        <div className="inMenuItem">
          <span className={isMayorGeneral ? "subTitle" : "linkSubtitulo"} onClick={() => setTab("MAYOR_GENERAL")}>
            Mayor General
          </span>
        </div>
        <div className="fix"></div>
      </div>
      <br />

      <DataTable
        id="grid"
        value={data || []}
        rowGroupMode="subheader"
        groupRowsBy="IdentificadorCuenta"
        sortMode="single"
        sortField="CuentaNombre"
        sortOrder={0}
        expandableRowGroups
        expandedRows={expandedRows}
        onRowToggle={(e) => {
          setExpandedRows(e.data);
        }}
        rowGroupHeaderTemplate={headerTemplate}
        rowGroupFooterTemplate={footerTemplate}
        loading={loading}
        emptyMessage="No se han encontrado resultados"
      >
        <Column header="Tipo" body={tipoTemplate}></Column>
        <Column header="Ref." body={referenciaTemplate}></Column>
        <Column field="Descripcion" header="Descripcion" style={{ maxWidth: "250px" }}></Column>
        <Column
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          header="Fecha"
          body={fechaTemplate}
        ></Column>
        <Column
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          header="Diario Id"
          body={diarioTemplate}
        ></Column>
        <Column
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          header="Débito"
          body={debitoTemplate}
        ></Column>
        <Column
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          header="Crédito"
          body={creditoTemplate}
        ></Column>
        <Column
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          header="Balance"
          body={balanceTemplate}
        ></Column>
      </DataTable>
    </div>
  );
};

const initialStateMayorGeneral = {
  where: {
    FechaInicio: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    FechaFin: new Date(),
    EsPaginable: true,
  },
};

export const BalanceGeneralMain = () => {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [tab, setTab] = React.useState("BALANCE_GENERAL");

  const isBalanceGeneral = tab === "BALANCE_GENERAL";
  const isMayorGeneral = tab === "MAYOR_GENERAL";

  const filtrosRef = useRef();

  /* Tabs */
  const [panels, setPanels] = useState([true, true]);
  const [expandedKeys, setExpandedKeys] = useState({});

  const [filtros, setFiltros] = useState(null);
  const [whereBalanceGeneral, setWhereBalanceGeneral] = useState({
    where: {},
  });
  const [whereMayorGeneral, setWhereMayorGeneral] = useState(initialStateMayorGeneral);

  /* formulario balance general */
  const [fecha, setFecha] = useState(() => new Date());
  const [periodoFiscal, setPeriodoFiscal] = useState(null);
  const [periodoContable, setPeriodoContable] = useState(null);
  const [expresadoEn, setExpresadoEn] = useState(null);

  /* formulario mayor general */
  const [formMayorGeneral, setFormMayorGeneral] = useState(initialForm);

  const [expresado, setExpresado] = useState(null);

  const {
    data: dataBalanceGeneral,
    loading: loadingBalanceGeneral,
    error: errorBalanceGeneral,
  } = useObtenerBalanceGeneral(whereBalanceGeneral);

  const {
    data: dataMayorGeneral,
    loading: loadingMayorGeneral,
    error: errorMayorGeneral,
  } = useObtenerMayorGeneral(whereMayorGeneral);

  const { data: dataExpresadoEn } = useExpresadoEn();

  React.useEffect(() => {
    if (!expresadoEn) {
      setExpresadoEn(dataExpresadoEn?.Resultados[0]);
    }
  }, [dataExpresadoEn]);

  const handleFiltro = (data) => {
    setFiltros(data);
    setTab("MAYOR_GENERAL");
  };

  return (
    <div className="form-reporte">
      <div className={isBalanceGeneral ? "" : "hidden"}>
        <BalanceGeneral
          data={dataBalanceGeneral}
          loading={loadingBalanceGeneral}
          setWhere={setWhereBalanceGeneral}
          where={whereBalanceGeneral}
          expandedKeys={expandedKeys}
          setExpandedKeys={setExpandedKeys}
          handleFiltro={handleFiltro}
          error={errorBalanceGeneral}
          form={{
            fecha,
            periodoFiscal,
            periodoContable,
            expresadoEn,
            setFecha,
            setPeriodoFiscal,
            setPeriodoContable,
            setExpresadoEn,
          }}
          dataExpresadoEn={dataExpresadoEn}
          expresado={expresado}
          setExpresado={setExpresado}
          isBalanceGeneral={isBalanceGeneral}
          isMayorGeneral={isMayorGeneral}
          setTab={setTab}
        />
      </div>
      <div className={isMayorGeneral ? "" : "hidden"}>
        <MayorGeneral
          data={dataMayorGeneral}
          loading={loadingMayorGeneral}
          filtros={filtros}
          setWhere={setWhereMayorGeneral}
          where={whereMayorGeneral}
          filtrosRef={filtrosRef}
          error={errorMayorGeneral}
          form={formMayorGeneral}
          setForm={setFormMayorGeneral}
          isBalanceGeneral={isBalanceGeneral}
          isMayorGeneral={isMayorGeneral}
          setTab={setTab}
        />
      </div>
    </div>
  );
};

// const app = document.getElementById("app");
//
// const root = ReactDOM.createRoot(app);
//
// root.render(
//   <MessageProvider>
//     <Tab />
//   </MessageProvider>
// );
